export const list = [
  // {
  //   key: 'voyager',
  //   title: "Introducing Vishwa Voyager",
  //   subTitle: "The trustless and secure messaging and verification infrastructure on/off BTC L1",
  //   anchorList:[
  //     {
  //       href: '#Landscape',
  //       title: 'The Current Landscape'
  //     },
  //     //  {
  //     //   href: '#Voyager',
  //     //   title: 'Voyager'
  //     // },
  //     {
  //       href: '#Architecture',
  //       title: 'A Modular Architecture'
  //     }, {
  //       href: '#Benefits',
  //       title: 'Who Benefits from Voyager?'
  //     }, {
  //       href: '#Next',
  //       title: 'What’s Next?'
  //     }, {
  //       href: '#DevNet',
  //       title: 'Internal Dev-net for Voyager'
  //     }, {
  //       href: '#LightClient',
  //       title: 'Revealing the Unified zk Light Client'
  //     }, {
  //       href: '#Launch',
  //       title: 'Public Testnet Launch'
  //     }, {
  //       href: '#Build',
  //       title: 'Build with Voyager'
  //     }, {
  //       href: '#Expanding',
  //       title: 'Expanding Ecosystem Partnerships'
  //     }, {
  //       href: '#Contact',
  //       title: 'Contact Us'
  //     }, {
  //       href: '#Acknowledgements',
  //       title: 'Acknowledgements'
  //     }
  //
  //   ],
  //   contentList: [
  //     {
  //       id: '',
  //       subTitle: '',
  //       subChildren: [
  //         {
  //           type: 'text',
  //           text: 'Today we introduce Voyager, Vishwa’s trustless and secure messaging and verification infrastructure on/off BTC L1. It is the first unified light client that enables the trustless message relay and verification between BTC mainnet and other ecosystems with zero knowledge technology. Through this blog post we explain the core components of Voyager and how it works.'
  //         }, {
  //           type: 'text',
  //           text: 'Blockchain technology has unlocked unprecedented possibilities for dApps and other financial scenarios, yet the barriers between ecosystems remain a significant challenge. Bitcoin, the most secure blockchain, and other widely adopted ecosystems, such as Ethereum, operate in silos, limiting their combined potential and introducing significant fragmented liquidity. This gap underscores the need for a trustless cross-chain message relayer and verifier — a component that allows seamless, secure, and verifiable interactions between these ecosystems without compromising decentralization.'
  //         }
  //       ]
  //     },
  //     {
  //       id: 'Landscape',
  //       subTitle: 'The Current Landscape: Fragmentation and Limitations',
  //       subChildren: [
  //         {
  //           type: 'text',
  //           text: 'Existing solutions for cross-chain interactions attempt to bridge this gap, but they come with significant trade-offs. Centralized bridges, for example, rely on custodians to manage assets between chains. While effective in theory, this approach introduces a single point of failure, making these systems vulnerable to hacks, fraud, and operational errors. Similarly, centralized validators, often used in cross-chain solutions, require participants to trust third parties, which undermines the very ethos of decentralization.'
  //         }, {
  //           type: 'text',
  //           text: 'For Bitcoin specifically, interoperability challenges are compounded by its design. Bitcoin’s SPV (Simplified Payment Verification) model provides a lightweight way to verify transactions but lacks the ability to support the complex computations required for modern decentralized finance (DeFi) and payment finance (PayFi) applications. This limitation makes it difficult to integrate Bitcoin seamlessly into multi-chain ecosystems, leaving a significant portion of its liquidity untapped and idle.'
  //         }, {
  //           type: 'text',
  //           text: 'Additionally, many solutions introduce scalability and efficiency challenges. Cross-chain interactions often require extensive data to be relayed and verified, which can result in high computational and gas costs, especially on chains like Ethereum. This inefficiency not only slows down transactions but also makes them economically unfeasible for many users.'
  //         }
  //       ]
  //     },
  //     // {
  //     //   id: 'Voyager',
  //     //   subTitle: 'Voyager: The Unified zk Light Client for Seamless Bitcoin Interoperability\n',
  //     //   subChildren: [
  //     //     {
  //     //       type: 'text',
  //     //       text: 'Voyager is our answer to this challenge: a unified zk light client designed to integrate Bitcoin Layer 1 with other Turing-complete execution layers. Leveraging advanced cryptography, including zkSNARKs, UniPlonk-optimized proofs, and a modular partitioning model, Voyager enables trustless cross-chain message verification and asset transfer. With Voyager, developers can unlock Bitcoin’s liquidity and security for decentralized finance (DeFi) and payment finance (PayFi), cross-chain governance, and other advanced applications without relying on centralized intermediaries or introducing additional layers of trust.'
  //     //     }, {
  //     //       type: 'text',
  //     //       text: 'The three guiding principles around Voyager’s initial design: Decoupled Proof Generation, Bidirectional Proof Delivery, and Dynamic Dispute Resolution.'
  //     //     }, {
  //     //       type: 'img',
  //     //       imgNotice: 'Branching of input/outputs of message relaying in Vishwa',
  //     //       text: 'https://miro.medium.com/v2/resize:fit:1400/format:webp/1*PvJ2Qj2skM5NobbzRjkfNA.jpeg',
  //     //     }, {
  //     //       type: 'mix',
  //     //       text: '* Vishwa Apollo design please refer to',
  //     //       aText: 'https://link.medium.com/JpSydYGe8Pb',
  //     //       aLink: 'https://link.medium.com/JpSydYGe8Pb',
  //     //     }, {
  //     //       type: 'text',
  //     //       text: 'Voyager separates computationally intensive tasks, such as zk-proof generation, from the on-chain execution. By performing these complex operations off-chain, Voyager minimizes on-chain gas costs and ensures scalability without burdening the network. This approach makes it feasible to validate intricate cross-chain interactions while maintaining economic efficiency.'
  //     //     }, {
  //     //       type: 'text',
  //     //       text: 'Voyager employs a secure and efficient mechanism for relaying proofs between Bitcoin and execution layers like Ethereum. This ensures that state transitions remain synchronized across chains, with proofs compressing critical data to optimize bandwidth and reduce latency. For users, this means seamless interoperability and a unified experience across ecosystems.'
  //     //     }, {
  //     //       type: 'img',
  //     //       imgNotice: 'Workflow between Bitcoin and execution layers through Vishwa’s Voyager',
  //     //       text: 'https://miro.medium.com/v2/resize:fit:1400/format:webp/1*WSrV1s65kY9fabWsfqiyag.jpeg',
  //     //     }, {
  //     //       type: 'mix',
  //     //       text: '* Vishwa Apollo design please refer to',
  //     //       aText: 'https://link.medium.com/JpSydYGe8Pb',
  //     //       aLink: 'https://link.medium.com/JpSydYGe8Pb',
  //     //     }, {
  //     //       type: 'text',
  //     //       text: 'Voyager introduces a fraud-proof mechanism that allows challengers to contest incorrect proofs. This ensures that invalid or malicious state transitions are detected and penalized, providing a robust layer of security for cross-chain interactions. Voyager’s design guarantees data integrity while maintaining a decentralized and trustless environment.'
  //     //     }, {
  //     //       type: 'img',
  //     //       imgNotice: 'How Challenger Works in Vishwa Voyager',
  //     //       text: 'https://miro.medium.com/v2/resize:fit:1400/format:webp/1*JGXW2Yum4w4JP_DClyYdBg.png',
  //     //     }, {
  //     //       type: 'text',
  //     //       text: 'Voyager combines the best of Bitcoin’s security and the programmability of other Turing-completed execution layers, creating a unified light client that redefines cross-chain operability. By transforming Bitcoin into a cornerstone of the multi-chain ecosystem, Voyager paves the way for a future where developers and users can seamlessly interact across networks without compromising on security, efficiency, or trustlessness.'
  //     //     }
  //     //   ]
  //     // },
  //     {
  //       id: 'Architecture',
  //       subTitle: 'A Modular Architecture',
  //       subChildren: [
  //         {
  //           type: 'text',
  //           text: 'Voyager’s design is built upon a modular architecture that combines the strengths of cryptographic proof systems and Bitcoin’s robust foundational security. This architecture is purposefully designed to enable seamless interoperability between Bitcoin and other Turing-complete execution layers while maintaining trustlessness and scalability.'
  //         }, {
  //           type: 'text',
  //           text: 'At the heart of Voyager is the zkVM, a highly efficient virtual machine optimized to process zero-knowledge proofs. This component allows compressed cryptographic proofs, such as zkSNARKs, to be verified on EVM-compatible chains like Ethereum. By enabling succinct validation of complex state transitions, the zkVM minimizes computational overhead and reduces costs, making cross-chain interactions both efficient and economically viable. The zkVM is paired with a novel proof compression architecture that eliminates the need for bulky fraud proofs and sequential verification models. Built on the UniPlonk protocol, Voyager introduces protocol-aware compression techniques that aggregate thousands of state transitions into a single, constant-sized proof. This innovation achieves up to 500x reduction in proof size and 25x lower on-chain costs, while preserving full trustlessness.'
  //         }, {
  //           type: 'text',
  //           text: 'Complementing this is Voyager’s modular computational model that breaks verification tasks into independent sub-computations. These are organized through a dependency graph and processed in parallel, significantly improving throughput and scalability. During dispute resolution, only relevant subcomponents are revealed, minimizing on-chain overhead while maintaining verifiability.'
  //         }, {
  //           type: 'text',
  //           text: 'Together, this system forms a modular framework that allows Voyager to seamlessly bridge Bitcoin’s secure infrastructure with the programmability of other chains. This architecture not only preserves Bitcoin’s integrity but also unlocks its potential as a settlement layer for a multi-chain ecosystem. By decoupling proof generation, validation, and execution, Voyager offers a scalable, flexible, and trustless solution for the next generation of blockchain applications.'
  //         }
  //       ]
  //     },
  //     {
  //       id: 'Benefits',
  //       subTitle: 'Who Benefits from Voyager?',
  //       subChildren: [
  //         {
  //           type: 'text',
  //           text: 'A diverse range of participants in the blockchain ecosystem will benefit from the Voyager’s design.'
  //         }, {
  //           type: 'text',
  //           text: 'For asset managers and developers, Voyager introduces a trustless mechanism for wrapping native Bitcoin into tokenized assets on other execution layers chains, enabling secure and decentralized asset transfers across blockchains, eliminating reliance on centralized bridges or custodial solutions. This functionality empowers participants to unlock the vast liquidity of idle Bitcoin and deploy it into DeFi and PayFi protocols, liquidity pools, or other financial instruments.'
  //         }, {
  //           type: 'text',
  //           text: 'Governance enthusiasts and DAO participants also stand to benefit. Voyager enables Bitcoin holders to participate in governance mechanisms on chains like Ethereum through verifiable state transitions. By allowing Bitcoin-backed assets to represent voting power or stakes in DAOs, Voyager ensures that Bitcoin’s value can actively contribute to decentralized decision-making across ecosystems.'
  //         }, {
  //           type: 'text',
  //           text: 'DeFi and PayFi users and developers will experience seamless integration of Bitcoin into multi-chain financial applications. With Voyager, Bitcoin can serve as a foundational asset in DeFi and PayFi protocols, enabling use cases such as lending, borrowing, and trading without requiring trust in intermediaries. This interoperability expands the potential of Bitcoin from a store of value to a key player in programmable financial ecosystems.'
  //         }, {
  //           type: 'text',
  //           text: 'Voyager’s design transforms how users, developers, and institutions interact with Bitcoin, providing new avenues for decentralized innovation and collaboration across chains.'
  //         }
  //       ]
  //     },
  //     {
  //       id: 'Next',
  //       subTitle: 'What’s Next?',
  //       subChildren: []
  //     },
  //     {
  //       id: 'DevNet',
  //       subTitle: 'Internal Dev-net for Voyager',
  //       subChildren: [
  //         {
  //           type: 'text',
  //           text: 'We are actively running an internal dev-net of Voyager to test critical functionalities and ensure seamless integration with infrastructure partners. The focus is on validating cross-chain message verification, and optimizing zkSNARKs.'
  //         }, {
  //           type: 'text',
  //           text: 'If you are an infrastructure provider interested in collaborating with us to enhance Voyager’s ecosystem, please reach out at official@vishwanetwork.xyz'
  //         }
  //       ]
  //     },
  //     {
  //       id: 'LightClient',
  //       subTitle: 'Revealing the Unified zk Light Client',
  //       subChildren: [
  //         {
  //           type: 'text',
  //           text: 'Voyager’s unified zk light client design will be unveiled soon. This includes detailed insights into our trustless mechanism, connecting Bitcoin with other execution layers. Stay tuned for announcements and open-source releases in the coming weeks.'
  //         }
  //       ]
  //     },
  //     {
  //       id: 'Launch',
  //       subTitle: 'Public Testnet Launch',
  //       subChildren: [
  //         {
  //           type: 'text',
  //           text: 'The Voyager public testnet is under active development and nearing completion. This milestone will allow developers, researchers, and early adopters to experience Voyager’s capabilities firsthand. Keep an eye on our blog and social channels for updates on the launch timeline and access details.'
  //         }
  //       ]
  //     },
  //     {
  //       id: 'Build',
  //       subTitle: 'Build with Voyager',
  //       subChildren: [
  //         {
  //           type: 'text',
  //           text: 'We are thrilled to announce the upcoming release of Voyager’s SDK, enabling developers to integrate trustless cross-chain solutions into their applications. Whether you’re building in DeFi, PayFi, governance, or gaming, Voyager offers the tools to seamlessly connect Bitcoin with programmable blockchains.'
  //         }, {
  //           type: 'text',
  //           text: 'Our developer portal will open soon with comprehensive documentation and tutorials. Sign up on vishwanetwork.xyz for updates or contact us at official@vishwanetwork.xyz to start building with Voyager.'
  //         }
  //       ]
  //     },
  //     {
  //       id: 'Expanding',
  //       subTitle: 'Expanding Ecosystem Partnerships',
  //       subChildren: [
  //         {
  //           type: 'text',
  //           text: 'Voyager is more than a protocol; it’s a bridge to the future of blockchain interoperability. We are actively exploring partnerships to expand its ecosystem. If you represent a protocol, exchange, or infrastructure provider looking to integrate Bitcoin, we’d love to collaborate.'
  //         }, {
  //           type: 'text',
  //           text: 'Reach out at official@vishwanetwork.xyz to discuss potential opportunities.'
  //         }
  //       ]
  //     },
  //     {
  //       id: 'Contact',
  //       subTitle: 'Contact Us',
  //       subChildren: [
  //         {
  //           type: 'text',
  //           text: 'We are excited to hear from you! Whether you are a developer, researcher, or blockchain enthusiast, your insights and feedback are invaluable to us. To learn more about Voyager, share ideas, or explore collaboration opportunities, feel free to reach out:'
  //         }, {
  //           type: 'text',
  //           text: 'Email: official@vishwanetwork.xyz'
  //         }, {
  //           type: 'mix',
  //           text: 'X: ',
  //           aText: '@vishwa_xyz',
  //           aLink: 'https://x.com/Vishwa_xyz'
  //         }, {
  //           type: 'mix',
  //           text: 'TG:',
  //           aText: 'https://t.me/vishwa_xyz/74204',
  //           aLink: 'https://t.me/vishwa_xyz/74204',
  //           text2: ' Join our community for real-time discussions and updates.'
  //         }, {
  //           type: 'text',
  //           text: 'Let’s shape the future of blockchain interoperability together.'
  //         },
  //       ]
  //     },
  //     {
  //       id: 'Acknowledgements',
  //       subTitle: 'Acknowledgements',
  //       subChildren: [
  //         {
  //           type: 'text',
  //           text: 'We extend our gratitude to the global blockchain community for their relentless pursuit of innovation and collaboration. Special thanks to the pioneers in cryptographic research, including, but not limited to RiscZero’s team, James @ Panga Capital, and other decentralized infrastructure enthusiasts whose work has laid the foundation for Voyager. Your contributions inspire us to push the boundaries of what’s possible in blockchain technology.'
  //         }, {
  //           type: 'text',
  //           text: 'We also thank our early adopters and testers for their invaluable feedback, which has been instrumental in shaping Voyager into the robust and efficient platform it is today. Your trust and support drive our mission to bring trustless interoperability to the blockchain ecosystem.'
  //         }
  //       ]
  //     },
  //   ]
  // },
  {
    key: 'apollo',
    title: "Introducing Vishwa’s Apollo",
    subTitle: "The first trustless self-custody BTC asset management infrastructure",
    anchorList:[
      {
        href: '#Challenges',
        title: 'Challenges Bitcoin'
      }, {
        href: '#Design',
        title: 'Design'
      }, {
        href: '#Benefits',
        title: 'Who Benefits from Apollo?'
      }, {
        href: '#Modular',
        title: 'A Modular Design Principle'
      }, {
        href: '#NewEra',
        title: 'A New Era for Bitcoin'
      }, {
        href: '#Contact',
        title: 'Contact Us'
      }
    ],
    contentList: [
      {
        id: '',
        subTitle: '',
        subChildren: [
          {
            type: 'text',
            text: 'Today we introduce Vishwa’s Apollo: the first trustless self-custody BTC asset management infrastructure. Through this blog post we explain the core components of Apollo and how it works.'
          }, {
            type: 'text',
            text: 'Bitcoin has proven itself as the gold standard of blockchain security and decentralization, boasting unmatched reliability as a store of value. However, its design prioritizes simplicity and security over scalability and programmability, which limits its integration into high-frequency financial applications and decentralized finance (DeFi) and payment finance (PayFi). While Bitcoin continues to dominate as a secure settlement layer, its utility remains underused, with over 90% of BTC laying idle in cold storage or long-term holdings.'
          }, {
            type: 'text',
            text: 'Vishwa Apollo reimagines Bitcoin’s scalability and financial utility by introducing HTLC-based Hyperchannels, a groundbreaking architecture that unlocks instantaneous transaction finality, dynamic liquidity management, and trustless interoperability. With Apollo, Bitcoin can transcend its limitations, enabling seamless integration into DeFi & PayFi ecosystems and driving its adoption as a programmable asset without sacrificing security or decentralization.'
          }
        ]
      },
      {
        id: 'Challenges',
        subTitle: 'The Challenges Bitcoin Faces Today',
        subChildren: [
          {
            type: 'text',
            text: 'Despite its dominance, Bitcoin’s current infrastructure struggles to meet the demands of modern blockchain applications, including, but not limited to, Limited Throughput, Liquidity Fragmentation, and Lack of Programmability.'
          }, {
            type: 'text',
            text: 'Bitcoin’s Layer 1 (L1) network processes only around 7 transactions per second (TPS), making it unsuitable for high-frequency use cases. Also, with the majority of BTC locked in long-term holdings, there is minimal active liquidity for use in financial applications. In addition, Bitcoin’s script is intentionally limited, which prevents it from supporting complex decentralized applications (dApps) or advanced financial instruments. Existing solutions, such as the Lightning Network, address scalability but come with multiple custodial risks, liquidity fragmentation, and complex channel management.'
          }
        ]
      },
      {
        id: 'Design',
        subTitle: 'The Apollo Design',
        subChildren: [
          {
            type: 'text',
            text: 'Apollo addresses the above limitations head-on, providing a trustless framework that preserves Bitcoin’s core principles while extending its utility into new domains. It is built around Hyperchannels, a decentralized channel architecture powered by Hash Time-Locked Contracts (HTLCs). Hyperchannels enable a secure, scalable, and efficient off-chain system for managing liquidity and transactions. By leveraging HTLCs, Apollo ensures that transactions remain atomic and verifiable, while state updates are periodically synchronized with Bitcoin L1 to maintain immutability.'
          }, {
            type: 'img',
            text: 'https://miro.medium.com/v2/resize:fit:1400/format:webp/1*Sm1ENvlKhcb8JAc02-g9Qw.png',
            imgNotice: 'User self-custodies with Apollo and the state is transmitted to the target chain, trustlessly'
          }, {
            type: 'text',
            text: 'Dynamic Liquidity Management is another key innovation in Apollo. Hyperchannels aggregate and dynamically adjust liquidity pools, ensuring participants can access sufficient liquidity even during periods of high demand. This eliminates the inefficiencies of fragmented liquidity pools seen in existing Layer 2 solutions, enabling smoother and faster transactions.'
          }, {
            type: 'text',
            text: 'The position and action message will be trustlessly transmitted to the other execution layers via Vishwa Voyager, our Unified zk light client.'
          }, {
            type: 'img',
            text: 'https://miro.medium.com/v2/resize:fit:1400/format:webp/1*PvJ2Qj2skM5NobbzRjkfNA.jpeg',
            imgNotice: 'Branching of input/outputs of message relaying in Vishwa'
          }, {
            type: 'mix',
            text: '*Introducing Vishwa Voyager: The the trustless and secure messaging and verification infrastructure on/off BTC L1:',
            aText: 'https://link.medium.com/ciJBS34g8Pb',
            aLink: 'https://link.medium.com/ciJBS34g8Pb'
          }
        ]
      },
      {
        id: 'Benefits',
        subTitle: 'Who Benefits from Apollo?',
        subChildren: [
          {
            type: 'text',
            text: 'Apollo opens up new opportunities for Bitcoin holders, developers, and financial institutions. For individual users, Apollo provides a simple, secure, and decentralized way to unlock idle BTC and participate in DeFi & PayFi applications like lending, trading, and liquidity provisioning. By leveraging Bitcoin’s liquidity through HTLC-based Hyperchannels, users gain access to high-speed transactions without needing custodial services or intermediaries.'
          }, {
            type: 'text',
            text: 'Developers can build new applications that integrate Bitcoin into programmable ecosystems without the need to rely on external chains or centralized bridges. Apollo’s trustless design makes it a robust foundation for creating innovative cross-chain financial instruments and dApps.'
          }, {
            type: 'text',
            text: 'Financial institutions also benefit from Apollo’s scalability and security, enabling them to use Bitcoin as a backbone for high-frequency trading, cross-border payments, and as a settlement infrastructure. By enhancing Bitcoin’s transactional capabilities, Apollo transforms it into a programmable asset that can power the future of decentralized finance.'
          }
        ]
      },
      {
        id: 'Modular',
        subTitle: 'A Modular Design Principle',
        subChildren: [
          {
            type: 'text',
            text: 'Apollo’s architecture is designed to be flexible and modular, ensuring seamless integration with Bitcoin L1 while providing developers with tools to extend its functionality. The system dynamically manages HTLC-based transactions, enabling instant finality and maintaining security through periodic on-chain synchronization.'
          }, {
            type: 'text',
            text: 'Apollo’s modular design ensures that developers can adapt it to diverse use cases while maintaining Bitcoin’s uncompromising security and trustlessness. By focusing on scalability, programmability, and decentralization, Apollo empowers Bitcoin to serve as a foundational layer for global financial innovation.'
          }
        ]
      },
      {
        id: 'NewEra',
        subTitle: 'A New Era for Bitcoin',
        subChildren: [
          {
            type: 'text',
            text: 'Vishwa’s Apollo redefines Bitcoin’s scalability and utility, enabling it to evolve from a store of value into a dynamic and programmable financial asset. With Apollo’s trustless design, Bitcoin can seamlessly integrate into DeFi and PayFi, support high-frequency financial applications, and power cross-border payments — all while maintaining its hallmark security and decentralization.'
          }, {
            type: 'text',
            text: 'The future of Bitcoin is here, and it starts with Apollo. Join us in unlocking Bitcoin’s full potential and building a more scalable and interoperable decentralized future.'
          }
        ]
      },
      {
        id: 'Contact',
        subTitle: 'Contact Us',
        subChildren: [
          {
            type: 'text',
            text: 'We’re eager to collaborate and hear your insights:'
          }, {
            type: 'text',
            text: 'Email: official@vishwanetwork.xyz'
          }, {
            type: 'mix',
            text: 'Website: ',
            aText: 'vishwanetwork.xyz',
            aLink: 'https://vishwanetwork.xyz/'
          }, {
            type: 'mix',
            text: 'Twitter: ',
            aText: '@Vishwa_xyz',
            aLink: 'https://x.com/Vishwa_xyz'
          }, {
            type: 'text',
            text: 'Together, let’s unlock Bitcoin’s full potential.'
          },
        ]
      },
    ]
  }
]
